const jobsData = [
  {
    title: "Social Media Marketer",
    city: "Lahore",
    freelance: false,
    fullTime: false,
    internship: false,
    partTime: true,
    temporary: false,
    type: "Part Time",
    date: "August 7,2020",
    description: {
      companyDetail:
        "InvoZone is a growing company in Lahore that offers a combination of consulting, outsourcing and specialized services to global clientele across all types of web and mobile app development.The company was launched by experienced and visionary IT professionals with more than 10 years of industry experience in the fraternity of software development. Invozone aspires to automate the daily work processes of clients with innovative business solutions with a vision to produce efficient and time-saving results.We take pride in our diversified team that consist people from both domestic and international backgrounds working together to strive excellence.While we have attained several milestones in very less time, it is just a warmup for us! If you think you have the technical skills to contribute in our fast-growing business, feel free to apply!",
      responsibilites: [
        "Develop, implement and manage our social media strategy",
        "Define most important social media KPIs",
        "Manage and oversee social media content",
        "Measure the success of every social media campaign",
        "Stay up to date with the latest social media best practices and technologies",
        "Use social media marketing tools such as Buffer",
        "Attend educational conferences",
        "Work with copywriters and designers to ensure content is informative and appealing",
        "Collaborate with Marketing, Sales and Product Development teams",
        "Monitor SEO and user engagement and suggest content optimization",
        "Communicate with industry professionals and influencers via social media to create a strong network",
        "Hire and train others in the team",
        "Provide constructive feedback",
      ],
      mustHave: [
        "2 years of experience as a Social Media Specialist or similar role",
        "Social Media Strategist using social media for brand awareness and impressions",
        "Excellent knowledge of Facebook, Twitter, LinkedIn, Pinterest, Instagram, Google+ and other social media best practices",
        "Understanding of SEO and web traffic metrics",
        "Experience with doing audience and buyer persona research",
        "Good understanding of social media KPIs",
        "Familiarity with web design and publishing",
        "Excellent multitasking skills",
        "Critical thinker and problem-solving skills",
        "Team player",
        "Good time-management skills",
        "Great interpersonal and communication skills",
        "BSc degree in Marketing or relevant field",
      ],
      perksBenefits: [
        "24 Paid Holidays",
        "In-patient and Out-patient medical coverage",
        "Gratuity",
        "Annual Increments",
        "Gym allowance",
        "Personal Development Fund",
        "Training Fund",
        "Vehicle Lease",
        "Weekends are off!",
        "Be a part of growing and dynamic team",
        "Opportunities for personal and professional growth",
      ],
    },
  },
  {
    title: "Software Intern",
    city: "Hasilpur",
    freelance: false,
    fullTime: true,
    internship: false,
    partTime: false,
    temporary: false,
    type: "Full Time",
    date: "2020",
    description: {
      companyDetail: "",
      responsibilites: [""],
      mustHave: [""],
      perksBenefits: [""],
    },
  },
];

export default jobsData;
